(function () {
  'use strict';

  var configuratorRoot = document.querySelector('[data-custom-chopstick-configurator-root]');
  if (
    !configuratorRoot ||
    !configuratorRoot.configuratorArtwork ||
    !configuratorRoot.configuratorLayouts ||
    !configuratorRoot.productStage
  ) return;
  if (configuratorRoot.getAttribute('data-configurator-flat-view-initialized') === 'true') return;

  var flatView = configuratorRoot.querySelector('[data-configurator-flat-view]');
  var status = flatView && flatView.querySelector('[data-configurator-flat-status]');
  var sideButtons = flatView && flatView.querySelectorAll('[data-configurator-flat-side]');
  var surfaceElements = flatView && flatView.querySelectorAll('[data-configurator-flat-surface]');
  var canvasElements = flatView && flatView.querySelectorAll('[data-configurator-flat-canvas]');
  var lengthLabels = flatView && flatView.querySelectorAll('[data-configurator-flat-length]');
  var heightLabels = flatView && flatView.querySelectorAll('[data-configurator-flat-height]');
  if (
    !flatView ||
    !status ||
    !sideButtons.length ||
    surfaceElements.length !== 2 ||
    canvasElements.length !== 2
  ) return;

  var layouts = configuratorRoot.configuratorLayouts;
  var productStage = configuratorRoot.productStage;
  var compactQuery = window.matchMedia && window.matchMedia('(max-width: 899px)');
  var canvases = {};
  var activeSide = 'front';
  var currentArtwork = null;
  var artworkReady = false;
  var workspaceActive = false;
  var unsubscribeArtwork = null;
  var destroyed = false;

  Array.prototype.forEach.call(canvasElements, function (canvas) {
    canvases[canvas.getAttribute('data-configurator-flat-canvas')] = canvas;
  });

  configuratorRoot.setAttribute('data-configurator-flat-view-initialized', 'true');
  configuratorRoot.setAttribute('data-configurator-flat-ready', 'false');
  applyPhysicalConventions();
  drawSurfaces();
  updateSideControls();

  function formatDimension(primary, secondary, primaryUnit, secondaryUnit) {
    return primary + primaryUnit + ' · ' + secondary + ' ' + secondaryUnit;
  }

  function applyPhysicalConventions() {
    var artworkSize = layouts.artworkSize;
    var safeArea = layouts.safeArea;
    var physicalSize = layouts.physicalSize;
    flatView.style.setProperty('--flat-aspect-ratio', artworkSize.width + ' / ' + artworkSize.height);
    flatView.style.setProperty('--flat-safe-left', safeArea.x / artworkSize.width * 100 + '%');
    flatView.style.setProperty('--flat-safe-top', safeArea.y / artworkSize.height * 100 + '%');
    flatView.style.setProperty('--flat-safe-width', safeArea.width / artworkSize.width * 100 + '%');
    flatView.style.setProperty('--flat-safe-height', safeArea.height / artworkSize.height * 100 + '%');
    Object.keys(canvases).forEach(function (side) {
      canvases[side].width = artworkSize.width;
      canvases[side].height = artworkSize.height;
    });
    Array.prototype.forEach.call(lengthLabels, function (label) {
      label.textContent = formatDimension(physicalSize.widthInches, physicalSize.widthCentimeters, '″', 'cm');
    });
    Array.prototype.forEach.call(heightLabels, function (label) {
      label.textContent = formatDimension(physicalSize.heightInches, physicalSize.heightCentimeters, '″', 'cm');
    });
  }

  function drawEmptySurface(canvas) {
    var context = canvas.getContext('2d');
    context.clearRect(0, 0, canvas.width, canvas.height);
    context.fillStyle = '#f7f4ed';
    context.fillRect(0, 0, canvas.width, canvas.height);
  }

  function drawSide(side) {
    var canvas = canvases[side];
    if (!canvas) return;
    if (!currentArtwork || !currentArtwork[side]) {
      drawEmptySurface(canvas);
      return;
    }
    var context = canvas.getContext('2d');
    context.clearRect(0, 0, canvas.width, canvas.height);
    context.drawImage(currentArtwork[side], 0, 0, canvas.width, canvas.height);
  }

  function compactMode() {
    return compactQuery ? compactQuery.matches : window.innerWidth <= 899;
  }

  function statusText(artwork) {
    var sideDescription = compactMode() ? ' on the ' + activeSide + ' side' : ' on both sides';
    if (!artwork) return 'Preparing the flat sleeve view…';
    if (artwork.status === 'missing') return 'The original logo needs to be re-uploaded before this design can be shown.';
    if (artwork.status === 'temporary') return 'Previewing this layout' + sideDescription + '.';
    if (artwork.status === 'selected') return 'Showing the selected layout' + sideDescription + '.';
    return 'Showing the current working artwork' + sideDescription + '.';
  }

  function drawSurfaces() {
    drawSide('front');
    drawSide('back');
    if (currentArtwork) {
      flatView.setAttribute('data-configurator-flat-artwork-status', currentArtwork.status);
      flatView.setAttribute(
        'data-configurator-flat-layout',
        currentArtwork.document ? currentArtwork.document.provenance.sourceId : 'working'
      );
    }
    status.textContent = statusText(currentArtwork);
  }

  function updateAvailability() {
    var ready = workspaceActive && artworkReady;
    flatView.setAttribute('aria-hidden', ready ? 'false' : 'true');
    if (ready) flatView.removeAttribute('inert');
    else flatView.setAttribute('inert', '');
    configuratorRoot.setAttribute('data-configurator-flat-ready', ready ? 'true' : 'false');
  }

  function updateSideControls() {
    var isCompact = compactMode();
    Array.prototype.forEach.call(sideButtons, function (button) {
      var selected = button.getAttribute('data-configurator-flat-side') === activeSide;
      button.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });
    Array.prototype.forEach.call(surfaceElements, function (surface) {
      var selected = surface.getAttribute('data-configurator-flat-surface') === activeSide;
      surface.setAttribute('data-active', selected ? 'true' : 'false');
      surface.setAttribute('aria-hidden', isCompact && !selected ? 'true' : 'false');
      if (isCompact && !selected) surface.setAttribute('inert', '');
      else surface.removeAttribute('inert');
    });
    configuratorRoot.setAttribute('data-configurator-flat-side', activeSide);
    status.textContent = statusText(currentArtwork);
  }

  function presentationUsesFlatView() {
    var mode = configuratorRoot.getAttribute('data-configurator-presentation');
    return mode === 'hybrid' || mode === 'design-primary';
  }

  function syncProductView() {
    if (!destroyed && presentationUsesFlatView()) productStage.setView(activeSide);
  }

  function setSide(side, options) {
    if (destroyed || (side !== 'front' && side !== 'back')) return false;
    activeSide = side;
    updateSideControls();
    if (!options || options.syncProduct !== false) syncProductView();
    return true;
  }

  function setWorkspaceActive(active) {
    workspaceActive = Boolean(active);
    updateAvailability();
    return true;
  }

  function handleArtwork(artwork) {
    if (destroyed) return;
    currentArtwork = artwork;
    artworkReady = Boolean(artwork && artwork.front && artwork.back);
    drawSurfaces();
    updateAvailability();
  }

  function handleClick(event) {
    var button = event.target.closest('[data-configurator-flat-side]');
    if (button) setSide(button.getAttribute('data-configurator-flat-side'));
  }

  function handleKeydown(event) {
    var button = event.target.closest('[data-configurator-flat-side]');
    if (!button || ['ArrowLeft', 'ArrowRight', 'Home', 'End'].indexOf(event.key) === -1) return;
    event.preventDefault();
    var side = event.key === 'ArrowLeft' || event.key === 'Home' ? 'front' : 'back';
    setSide(side);
    flatView.querySelector('[data-configurator-flat-side="' + side + '"]').focus();
  }

  function handleCompactChange() {
    updateSideControls();
  }

  function handlePageHide(event) {
    if (!event.persisted) destroy();
  }

  function destroy() {
    if (destroyed) return;
    destroyed = true;
    if (unsubscribeArtwork) unsubscribeArtwork();
    flatView.removeEventListener('click', handleClick);
    flatView.removeEventListener('keydown', handleKeydown);
    window.removeEventListener('pagehide', handlePageHide);
    if (compactQuery) {
      if (compactQuery.removeEventListener) compactQuery.removeEventListener('change', handleCompactChange);
      else if (compactQuery.removeListener) compactQuery.removeListener(handleCompactChange);
    }
    configuratorRoot.removeAttribute('data-configurator-flat-view-initialized');
    configuratorRoot.removeAttribute('data-configurator-flat-ready');
    configuratorRoot.configuratorFlatView = null;
  }

  flatView.addEventListener('click', handleClick);
  flatView.addEventListener('keydown', handleKeydown);
  window.addEventListener('pagehide', handlePageHide);
  if (compactQuery) {
    if (compactQuery.addEventListener) compactQuery.addEventListener('change', handleCompactChange);
    else if (compactQuery.addListener) compactQuery.addListener(handleCompactChange);
  }
  unsubscribeArtwork = configuratorRoot.configuratorArtwork.subscribe(handleArtwork);
  configuratorRoot.configuratorFlatView = {
    getSide: function () { return activeSide; },
    setSide: setSide,
    setWorkspaceActive: setWorkspaceActive,
    syncProductView: syncProductView,
    destroy: destroy
  };
}());
